import React, { useEffect, useState } from 'react'
import styles from '../header/Header.module.css'
import ChatList from './ChatList'
import { useTranslation } from 'react-i18next'
import Avatar1 from '../../assets/new-right-menu/profile.svg'
import setting from '../../assets/new-right-menu/settings.svg'
import exitIcon from '../../assets/new-right-menu/onOff.svg'
import { ROUTE_LOGIN, ROUTE_USER_PROFILE } from '../../routes/routes-constants'
import { navigate } from '@reach/router'
import { getUserContainer } from 'container/user-module'
import { ILoggedUserService } from '../../modules/users/services/LoggedUserService'
import { IUserService, LOGGED_USER_SERVICE_KEY, USER_SERVICE_KEY } from '../../modules/users'
import { UserDTO, fromModel } from '../../modules/users/models/User'
import { Avatar, Box, Button, Menu, MenuItem } from '@mui/material'
import style from '../avatar-profile/AvatarProfile.module.css'
import { getFileContainer } from '../../container/file-module'
import { FileService } from '../../modules/files/services/FileService'
import { FILE_SERVICE_KEY } from '../../modules/files'
import { emptyFileDTO } from '../../modules/files/models/FileDTO'
import { useProfilePhotoGlobalContext } from '../../common/utils/ProfilePhotoContext'
import { useGotifyWebSocket } from 'components/useGotifyWebSocket'

const filesContainer = getFileContainer()
const fileService = filesContainer.get<FileService>(FILE_SERVICE_KEY)
const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)
const userService = getUserContainer().get<IUserService>(USER_SERVICE_KEY)

type CustomAppBarProps = {
  onChange?: () => void
}

type NotificationGotify = {
  id: string
  title: string
  message: string
  createAd: Date
}

const NavRight = (props: CustomAppBarProps) => {
  const { t } = useTranslation()
  const [listOpen, setListOpen] = useState<boolean>(false)
  const [user, setUser] = useState<UserDTO>()
  const { profilePhoto, setProfilePhoto } = useProfilePhotoGlobalContext()
  const [notifications, setNotifications] = useState<NotificationGotify[]>([])
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const loggedUser = loggedUserService.get()

  const { connected, notificationPermission, requestPermissions } = useGotifyWebSocket({
    serverUrl: 'https://backend-gotify.visualtis.com',
    token: user?.notificationsToken ?? '',
    onMessage: (message) => {
      console.log(user?.notificationsToken, 'Nuevo mensaje:', message, connected)
    },
  })

  // Solicitar permisos manualmente si es necesario
  if (notificationPermission !== 'granted') {
    console.log('Request PERMISSIONS')
    requestPermissions()
  } else {
    console.log('Permissions yes')
  }

  useEffect(() => {
    if (!loggedUser?.id) return
    //cargamos la foto de perfil
    fileService.getProfilePhotoByUserID(loggedUser.id).subscribe((res) => {
      setProfilePhoto(res || emptyFileDTO(''))
    })

    userService.getByID(loggedUser?.id).subscribe((res) => {
      console.log('>>>>DATA USER: ', res)
      res && setUser(fromModel(res))
    })
  }, [])

  const handleSetMenuSelected = (menuSelected: string) => {
    navigate(menuSelected)
  }

  const handleLogout = () => {
    loggedUserService.logout()
    navigate(ROUTE_LOGIN).then()
    props.onChange && props.onChange()
  }
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Box className={styles.navRightContainer} style={{ marginRight: '-1%' }}>
        <Button
          onClick={handleClick}
          sx={{
            color: 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 2,
          }}
        >
          <Avatar
            sx={{ width: '3rem', height: '3rem', marginRight: 1, objectFit: 'cover' }}
            className={style.profilepic__image}
            alt="Remy Sharp"
            src={
              profilePhoto.data.length > 0 ? `data:image/jpg;base64, ${profilePhoto.data}` : Avatar1
            }
          />
        </Button>
        <Box className="pro-body">
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{
              '& .MuiPaper-root': {
                borderRadius: '13px',
                transform: 'translate(-65px, 7px) !important',
              },
            }}
          >
            <MenuItem
              onClick={() => handleSetMenuSelected(ROUTE_USER_PROFILE)}
              className={styles.menuItem}
            >
              <img style={{ marginRight: 8 }} src={setting} alt={'profile'} />{' '}
              <span style={{ fontSize: 18, fontWeight: 600 }}>{t('profile')}</span>
            </MenuItem>
            <MenuItem onClick={handleLogout} className={styles.menuItem}>
              <img style={{ marginRight: 16 }} src={exitIcon} alt={'exit'} />{' '}
              <span style={{ fontSize: 18, fontWeight: 600 }}>{t('exit')}</span>
            </MenuItem>
          </Menu>
        </Box>
      </Box>
      <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
    </>
  )
}

export default NavRight
